import {AnyAction} from "redux";
import {SET_MODAL} from "./action";
import {MODALS} from "../reducers/modal";


/**
 * show a modal by ID
 * @param modal_id
 * @return {{type: string, payload: {modal_id: string}}}
 */
export function showModal(modal_id: string) : AnyAction
{
    return {type: SET_MODAL, payload: {modal_id}};
}


/**
 * hide the active modal
 * @return {{type: any, payload: {modal: string}}}
 */
export function hideModal() : AnyAction
{
    return {type: SET_MODAL, payload: {modal_id: null}};
}


/**
 * show the timer-start modal
 * @return {{type: string, payload: {modal_id: string}}}
 */
export function showTimerStartModal() : AnyAction
{
    return {type: SET_MODAL, payload: {modal_id: MODALS.TIMER_START}};
}



/**
 * show the power source details modal
 * @return {{type: string, payload: {modal: string}}}
 */
export function showPowerSourceDetailsModal() : AnyAction
{
    return {type: SET_MODAL, payload: {modal_id: MODALS.POWER_SOURCE_DETAILS}};
}


/**
 * show the game over modal
 * @return {{type: string, payload: {modal: string}}}
 */
export function showGameOverModal() : AnyAction
{
    return {type: SET_MODAL, payload: {modal_id: MODALS.GAME_OVER}};
}


/**
 * show the game over modal
 * @return {{type: string, payload: {modal: string}}}
 */
export function showHintsModal() : AnyAction
{
    return {type: SET_MODAL, payload: {modal_id: MODALS.HINT}};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/modals.ts